import React from 'react'
import styles from './styles.module.scss';
import img from "./image/abnormal.png"
 

function TicketRuleAbnormal() {
    return (
        <div className={styles.TicketRuleAbnormal}>
            <div className={styles.TicketRuleAbnormal_content}>
                <img className={styles.TicketRuleAbnormal_img} src={img} alt="異常圖" />
                <h2 className={styles.TicketRuleAbnormal_title}>查無票價規定內容</h2>
                <p className={styles.TicketRuleAbnormal_text}>很抱歉因系統資料異常，如需了解詳細票價規定請洽服務人員，謝謝您。</p>
            </div>
            
        </div>
    )
}

export default TicketRuleAbnormal




